import { EntityLink } from "../EntityLink";
import { MaxwellToolChip } from "../MaxwellToolChip";
import { collectEntityRefs } from "../entity-refs";
import type { AgentRunStep } from "@/types/maxwell-runs";

/** Pull the persisted error message off a failed step's `{ error }` result. */
function stepError(result: unknown): string | null {
  if (typeof result !== "object" || result === null) return null;
  const err = (result as { error?: unknown }).error;
  return typeof err === "string" && err.length > 0 ? err : null;
}

/**
 * A finished step's actual result, under its timeline row: the entities the
 * result cites as deep-link chips, a failed step's error in plain text, and
 * the raw payload behind a collapsible disclosure. Renders nothing while the
 * step has no result yet.
 */
export function StepResultDetails({ step }: { step: AgentRunStep }) {
  if (step.result == null) return null;

  const error = step.status === "failed" ? stepError(step.result) : null;
  const refs = collectEntityRefs(step.result);

  return (
    <div className="flex flex-col gap-1.5">
      {error && <p className="text-sm text-destructive">{error}</p>}
      {refs.length > 0 && (
        <div className="flex flex-wrap gap-x-3 gap-y-1">
          {refs.map((ref, i) => (
            <EntityLink key={`${ref.kind}:${ref.id}:${i}`} entity={ref} />
          ))}
        </div>
      )}
      <MaxwellToolChip toolName="result" payload={step.result} />
    </div>
  );
}
